import React, { useState, useEffect } from "react";
import { hardReloadScreen } from "./helpers/hardReloadScreen";

const NOT_FOUND_MESSAGE = "Nepodarilo sa načítať denné menu, ďalší pokus o:";
const RETRY_LABEL = "Skúsiť znova";

/**
 * Zobrazí chybu načítania denného menu.
 * Ak je error === "not-found", zobrazí odpočítavanie (COUNTDOWN_INTERVAL_MS) a po uplynutí obnoví stránku.
 */
function ErrorView({ error, onRetry, countdownIntervalMs, className = "daily-menu-screen" }) {
  const initialSeconds = Math.ceil((countdownIntervalMs || 10000) / 1000);
  const [countdownSeconds, setCountdownSeconds] = useState(initialSeconds);
  const isNotFound = error && String(error).trim() === "not-found";

  useEffect(() => {
    if (!isNotFound) return;
    setCountdownSeconds(initialSeconds);
    const interval = setInterval(() => {
      setCountdownSeconds((prev) => {
        if (prev <= 1) {
          hardReloadScreen();
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
    return () => clearInterval(interval);
  }, [isNotFound, initialSeconds]);

  if (isNotFound) {
    return (
      <div
        className={className}
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          minHeight: "100vh",
          padding: 24,
          textAlign: "center",
        }}
      >
        <p style={{ marginBottom: 16 }}>
          {NOT_FOUND_MESSAGE} {countdownSeconds} sekúnd.
        </p>
      </div>
    );
  }

  return (
    <div
      className={className}
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "100vh",
        padding: 24,
        textAlign: "center",
      }}
    >
      <p style={{ marginBottom: 16 }}>{error}</p>
      <button
        type="button"
        onClick={onRetry}
        style={{ padding: "8px 16px", cursor: "pointer" }}
      >
        {RETRY_LABEL}
      </button>
    </div>
  );
}

export default ErrorView;
